module.exports = __webpack_public_path__ + "static/media/Temp._icn.1c07a75f.svg";